export default "__VITE_ASSET__BDYLyd3A__"